var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.115356,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.115356,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2483)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.115356,
    width: 22,
    height: 16,
    fill: "#043CAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3746 3.42091L11.1153 3.2L11.8561 3.42091L11.6392 2.66667L11.8561 1.91242L11.1153 2.13333L10.3746 1.91242L10.5915 2.66667L10.3746 3.42091ZM10.3746 14.0876L11.1153 13.8667L11.8561 14.0876L11.6392 13.3333L11.8561 12.5791L11.1153 12.8L10.3746 12.5791L10.5915 13.3333L10.3746 14.0876ZM16.3534 8.53333L15.6127 8.75425L15.8296 8L15.6127 7.24575L16.3534 7.46667L17.0942 7.24575L16.8773 8L17.0942 8.75425L16.3534 8.53333ZM5.13647 8.75425L5.87725 8.53333L6.61803 8.75425L6.40106 8L6.61803 7.24575L5.87725 7.46667L5.13647 7.24575L5.35344 8L5.13647 8.75425ZM15.6517 5.86667L14.9109 6.08758L15.1279 5.33333L14.9109 4.57909L15.6517 4.8L16.3925 4.57909L16.1755 5.33333L16.3925 6.08758L15.6517 5.86667ZM5.83825 11.4209L6.57903 11.2L7.3198 11.4209L7.10283 10.6667L7.3198 9.91242L6.57903 10.1333L5.83825 9.91242L6.05522 10.6667L5.83825 11.4209ZM13.7344 3.91453L12.9936 4.13545L13.2106 3.3812L12.9936 2.62695L13.7344 2.84787L14.4752 2.62695L14.2582 3.3812L14.4752 4.13545L13.7344 3.91453ZM7.75552 13.3731L8.4963 13.1521L9.23708 13.3731L9.02011 12.6188L9.23708 11.8646L8.4963 12.0855L7.75552 11.8646L7.97249 12.6188L7.75552 13.3731ZM15.6517 11.2L14.9109 11.4209L15.1279 10.6667L14.9109 9.91242L15.6517 10.1333L16.3925 9.91242L16.1755 10.6667L16.3925 11.4209L15.6517 11.2ZM5.83825 6.08758L6.57903 5.86667L7.3198 6.08758L7.10283 5.33333L7.3198 4.57909L6.57903 4.8L5.83825 4.57909L6.05522 5.33333L5.83825 6.08758ZM13.7344 13.1521L12.9936 13.3731L13.2106 12.6188L12.9936 11.8646L13.7344 12.0855L14.4752 11.8646L14.2582 12.6188L14.4752 13.3731L13.7344 13.1521ZM7.75552 4.13545L8.4963 3.91453L9.23708 4.13545L9.02011 3.3812L9.23708 2.62695L8.4963 2.84787L7.75552 2.62695L7.97249 3.3812L7.75552 4.13545Z",
    fill: "#FFD429"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.8091a27154cfd0aaaeb318f9012a91bc.svg";
export { ForwardRef as ReactComponent };